import logo from "../logos/white.svg";

const style = {
  logo: {
    width: "240px",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2.5rem",
  },
};

function LoginFormLogo() {
  return (
    <div style={style.logo}>
      <img src={logo} alt="Logo" />
    </div>
  );
}

export default LoginFormLogo;
